import React from 'react'
import styled from "styled-components";
import { StaticImage } from "gatsby-plugin-image"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import WhiteButton from '../../components/Button/WhiteButton';
import {PhoneIcon} from '../../components/Icons';


const SlickCarousel = styled.div`
  position:relative;  
  padding:90px 0 0;
  @media (min-width: 1200px) {
    height:100vh;
    padding:0;
  }
`

const SlickCaption = styled.div`
    text-align:center;
    width:100%;
    margin:0 auto;
    padding:20px;
    border-bottom:1px solid rgba(233, 36, 42, 0.3);
    @media (min-width: 576px) {
        border-bottom:none;
        padding:0 20px;
        position:absolute;
        top:50%;
        left:50%;
        transform:translate(-50%, -50%);
        z-index: 1;
    }
	@media (min-width: 992px) {
		padding:0 30px;
	}
`

const SlickTitle = styled.h1`
    display:block;
    position:relative;
    font-weight:700;
    margin-bottom:5px;
    font-size: 20px;
    line-height: 30px;
    @media (min-width: 576px) {
        text-transform:uppercase;
        margin-bottom:10px;
        font-size: 28px;
        line-height: 38px;
        color:#fff;
    }
    @media (min-width: 768px) {
        font-size: 40px;
        line-height: 50px;
    }
    @media (min-width: 992px) {
        font-size: 60px;
        line-height: 70px;
    }
    @media (min-width: 1200px) {
        font-size: 70px;
        line-height: 80px;
    }
    @media (min-width: 1600px) {
        font-size: 80px;
        line-height: 90px;
    }
`
const SlickLead = styled.div`
    display:block;
    position:relative;
    margin-bottom:10px;
    font-weight:700;
    @media (min-width: 576px) {
        /* text-transform:uppercase; */
        margin-bottom:20px;
        color:#fff;
    }
    font-size: 16px;
    line-height: 28px;
    @media (min-width: 576px) {
        font-size: 22px;
        line-height: 32px;
    }
    @media (min-width: 768px) {
        font-size: 28px;
        line-height: 38px;
    }
    @media (min-width: 992px) {
        font-size: 34px;
        line-height: 44px;
    }
    @media (min-width: 1200px) {
        font-size: 40px;
        line-height: 50px;
    }
`

const SlickButton = styled.div`
    .btn{
        & .icon{
            > svg{
                width:20px;
                @media (min-width: 576px) {
                 width:28px;
                }
            }
            padding: 6px 6px 6px 20px;
            @media (min-width: 1200px) {
                padding: 8px 8px 8px 25px;
            }
            @media (min-width: 1600px) {
                padding: 12px 12px 12px 30px;
            }
        }
        & .text{            
            @media (max-width: 575.98px) {
                font-size: 14px;
                line-height: 30px;
                padding-right: 10px;
            }
        }

        
        background: #373636;
        color:#fff;	
        & .icon{
            > svg{
                fill:#fff;
            }
        }	
        &:before {
            background:#E9242A;
        }
        @media (min-width: 576px) {
            background: #373636;
            color:#373636;	
            & .icon{
                > svg{
                    fill:#373636;
                }
            }
            &:before {
                background: #fff;			
            }
            &:hover{
                color:#fff;	
                & .icon{
                    > svg{
                        fill:#fff;
                    }
                }
            }
            
        }
    }
`

const SlickImage = styled.div`
    position: relative;
    width: 100%;
    height:100%;
    .gatsby-image-wrapper{
        width: 100%;
        height:100%;
    }
    @media (min-width: 576px) {
        &:after{
            content:'';
            position:absolute;
            top:0;
            left:0;
            bottom:0;
            right:0;
            background-color:rgba(0,0,0,0.5);
        }
    }

`
const ScrollDowns = styled.div`
    position: absolute;
    bottom: 30px;
    right: 30px;
    @media (max-width: 575.98px) {
        display:none;
    }

    &:before{
        content:'';
        position:absolute;
        bottom:calc(100% + 20px);
        left:50%;
        transform:translateX(-50%);
        width:1px;
        height:96px;
        background-color:rgba(255,255,255,0.5);
    }
`

const Mousey = styled.div`
    width: 22px;
    height: 38px;
    border: 2px solid rgba(255,255,255,0.5);
    border-radius: 15px;
    text-align:center;
`
const Scroller = styled.div`
    margin:0 auto;
    width: 3px;
    height: 8px;
    border-radius: 4px;
    background-color: #fff;
    animation-name: scroll;
    animation-duration: 2.2s;
    animation-timing-function: cubic-bezier(.15,.41,.69,.94);
    animation-iteration-count: infinite;
`


const HeroCarousel = () => {
    return (
        <SlickCarousel>
            <SlickImage><StaticImage src="../../images/banner01.jpg" alt="banner01" /></SlickImage>
            <SlickCaption>
                <SlickTitle>Engineered Metal Buildings</SlickTitle>   
                <SlickLead>Precision Engineered By Experts</SlickLead>
                <SlickButton>
                <a href="tel:2085721441" aria-label="phone number">
                    <WhiteButton text="(208) 572-1441" icon={<PhoneIcon />} />
                </a>
                </SlickButton>    
            </SlickCaption>
            <ScrollDowns className="scroll-downs">
                <Mousey className="Mousey">
                    <Scroller className="scroller"></Scroller>
                </Mousey>
            </ScrollDowns>
        </SlickCarousel>
    );
}


export default HeroCarousel;